import 'alpinejs';
import 'lazysizes';
import GLightbox from 'glightbox';

$('.hamburger').on( "click", function() {
  $(this).toggleClass('is-active');
});

// hero and posts sliders
import 'slick-carousel';
$('.hero-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: !0,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    draggable: false,
    arrows: true,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',
    appendArrows: '.hero-slider-arrows',
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg class="svg-inline--fa fa-chevron-right fa-w-8 fill-current w-2" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg class="svg-inline--fa fa-chevron-right fa-w-8 fill-current w-2" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></button>',
    responsive: [
        {
            breakpoint: 400,
            settings: {
                adaptiveHeight: true,
            }
        },
    ]
});

jQuery('.hero-slider .hero-slider-arrows-mobile .slick-prev').on('click', function(){
	jQuery('.hero-slider').slick("slickPrev");
});
jQuery('.hero-slider .hero-slider-arrows-mobile .slick-next').on('click', function(){
	jQuery('.hero-slider').slick("slickNext");
});

var postSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    centerMode: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg class="svg-inline--fa fa-chevron-right fa-w-8 fill-current w-2" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg class="svg-inline--fa fa-chevron-right fa-w-8 fill-current w-2" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></button>',
    responsive: [
        {
            breakpoint: 780,
            settings: "unslick"
        }
    ]
};

var postsSlider =  $('.posts-slider').slick(postSettings);

$(window).on('resize', function() {
   if( $(window).width() > 780 &&  !postsSlider.hasClass('slick-initialized')) {
         $('.posts-slider').slick(postSettings);
    }
});


// menu sort
var Isotope = require('isotope-layout');
var imagesLoaded = require('imagesloaded');
var grid = document.querySelector('#grid');

if (grid) {
    var iso = new Isotope( grid, {
      itemSelector: '.grid-item',
    });

    imagesLoaded( grid ).on( 'progress', function() {
        // layout Isotope after each image loads
        iso.layout();
    });

    // bind filter button click
    // var filtersElem = document.querySelector('.filters-button-group');

    /*if (filtersElem) {
        filtersElem.addEventListener('click', function (event) {
            var filterValue = event.target.getAttribute('data-filter');
            // use matching filter function
            iso.arrange({filter: filterValue});
        });
    }*/

    // change is-checked class on buttons
    var buttonGroups = document.querySelectorAll('.btn-group');
    for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
      var buttonGroup = buttonGroups[i];
      radioButtonGroup( buttonGroup );
    }

    function radioButtonGroup( buttonGroup ) {
      buttonGroup.addEventListener( 'click', function( event ) {
        buttonGroup.querySelector('.active').classList.remove('active');
        event.target.classList.add('active');
      });
    }
}


// animations on floating fruits
let Rellax = require('rellax');
let rellax = new Rellax('.rellax', {
    center: true
});

setTimeout(() => {
    rellax.refresh();
}, 100);


var lightbox = GLightbox();
lightbox.on('open', (target) => {
    console.log('lightbox opened');
});


// accordion
export const accordion = () => {
  window.addEventListener('load', function () {
      const buttons = document.querySelectorAll('.accordion-button');

      if (0 === buttons.length) {
          return;
      }

      const hide = el => {
          el.style.height = '0px';
          el.setAttribute('aria-expanded', 'false');
      };

      for (let i = 0; i < buttons.length; i++) {
          const content = document.getElementById(buttons[i].getAttribute('aria-controls'));
          const height = content.clientHeight;

          hide(content);

          buttons[i].addEventListener('click', function (e) {
              e.preventDefault();
              for (let j = 0; j < buttons.length; j++) {
                  const controlledByButton = document.getElementById(buttons[j].getAttribute('aria-controls'));
                  if (e.currentTarget !== buttons[j] || e.currentTarget.classList.contains('expanded')) {
                      buttons[j].classList.remove('expanded');
                      hide(controlledByButton);
                  } else {
                      buttons[j].classList.add('expanded');
                      content.style.height = `${height}px`;
                      content.setAttribute('aria-expanded', 'true');
                  }
              }
          });
      }
  });
};
accordion();
